var _path, _circle, _path2, _path3, _path4, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5540,
    height: 5540,
    viewBox: "0 0 5540 5540",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5181.8 4346.89C5215.5 4309.42 5236 4259.86 5236 4205.5C5236 4088.69 5141.31 3994 5024.5 3994C4958.56 3994 4899.66 4024.18 4860.87 4071.48C4854.79 4071.16 4848.66 4071 4842.5 4071C4651.13 4071 4496 4226.13 4496 4417.5C4496 4608.87 4651.13 4764 4842.5 4764C5033.87 4764 5189 4608.87 5189 4417.5C5189 4393.3 5186.52 4369.68 5181.8 4346.89Z",
    fill: "#FE2B54"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4396,
    cy: 4967,
    r: 100,
    fill: "#FE2B54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4004 4474C4004 4569.46 4018.9 4661.44 4046.49 4747.75C4003.67 4737.45 3958.97 4732 3913 4732C3598.75 4732 3344 4986.75 3344 5301C3344 5361.55 3353.46 5419.89 3370.98 5474.63C3177.48 5517.43 2976.37 5540 2770 5540C1240.17 5540 0 4299.83 0 2770C0 1240.17 1240.17 0 2770 0C4299.83 0 5540 1240.17 5540 2770C5540 2954.27 5522.01 3134.34 5487.68 3308.54C5451.98 3294.01 5412.92 3286 5372 3286C5203.2 3286 5066.21 3422.24 5065.01 3590.76C5012.15 3581.06 4957.66 3576 4902 3576C4406.05 3576 4004 3978.05 4004 4474Z",
    fill: "#FE2B54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3575 2350.94V3806.08C3575 3832.6 3585.04 3858.75 3606.26 3874.66C3736.66 3972.43 3911.37 3926.79 4017.43 3874.23C4047.94 3859.11 4065 3826.9 4065 3792.84V3156C4065 3100.77 4109.77 3056 4165 3056H4314.58C4341.1 3056 4367.05 3045.74 4384.06 3025.39C4516.78 2866.54 4451.46 2710.77 4382.77 2629.48C4366.66 2610.42 4342.16 2601.5 4317.2 2601.5H4093.25C4058.04 2601.5 4029.5 2572.96 4029.5 2537.75C4029.5 2502.54 4058.04 2474 4093.25 2474H4228.08C4254.6 2474 4280.54 2463.74 4297.6 2443.43C4432.98 2282.24 4359.22 2133.83 4288.97 2062.85C4276.76 2050.52 4260.26 2043.31 4243.11 2040.67C3780 1969.54 3608.03 2198.47 3576.94 2332.34C3575.52 2338.46 3575 2344.66 3575 2350.94Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1301.5 2157.71V3803.63C1301.5 3842.82 1333.68 3874.37 1372.86 3873.61L2365.58 3854.32C2376.38 3854.11 2387.29 3851.28 2396.8 3846.17C2906.72 3571.82 2788.33 3170.61 2652.85 2984.47C2643.5 2971.63 2638 2956.35 2638 2940.46V2824.09C2638 2813.82 2640.41 2803.45 2644.62 2794.08C2843.01 2352.24 2543.82 2118.81 2357.38 2052.08C2349.49 2049.25 2341.21 2048.17 2332.84 2048.52L1368.65 2087.77C1331.13 2089.29 1301.5 2120.16 1301.5 2157.71Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2855,
    y: 2770,
    width: 567,
    height: 1154,
    rx: 200,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2855,
    y: 2048,
    width: 567,
    height: 567,
    rx: 200,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.246801227e7aa08e78d13e119edbcbcf.svg";
export { ForwardRef as ReactComponent };